// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".display-none[data-v-04bff5e0]{display:none}.quantity-selector[data-v-04bff5e0]{display:flex;flex-direction:row;align-items:center;justify-content:flex-start;padding:0;grid-gap:8px;gap:8px}.quantity-selector .unit[data-v-04bff5e0]{color:#2e2d2c;margin:0}.error-message[data-v-04bff5e0]{font-weight:500;font-size:12px;line-height:24px;display:flex;align-items:center;color:#ea0c27}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
